import { Component } from '@angular/core';

@Component({
  selector: 'app-error404',
  imports: [],
  template: `
    <p>
      error404 works!
    </p>
  `,
  styles: ``
})
export class Error404 {

}
